import React, { useCallback } from "react";
import { ReactComponent as ShopIcon } from "images/icons/shop-1.svg";
import { ReactComponent as CategoriesIcon } from "images/icons/list-bullets-1.svg";
import { ReactComponent as SearchIcon } from "images/icons/search-alternate.svg";
import { ReactComponent as CartIcon } from "images/icons/shopping-bag-side.svg";
import { useCart, useStorefrontConfig } from "../types/storefront";
import { restaurantPath, storeCartPath, storeCategoriesPath, storeSearchPath } from "src/routes";
import { NavigatePage, StorefrontPage, useNavigationState } from "../types/navigation";
import { MOBILE_PRODUCT_SEARCH_INPUT_ID } from "src/storefront/components/search_page";

const BottomNav = () => {
  const config = useStorefrontConfig();
  const cart = useCart();
  const [navigationState, updateNavigation] = useNavigationState();

  const changePage = useCallback((event: React.MouseEvent, newPage: StorefrontPage) => {
    event.preventDefault();

    updateNavigation(NavigatePage.action(newPage));
  }, [updateNavigation]);

  const navToShop = (event: React.MouseEvent) => {
    event.preventDefault();

    if (navigationState.currentPage === StorefrontPage.Shop) {
      window.scroll({ top: 0, behavior: "smooth" });
    } else {
      updateNavigation(NavigatePage.action(StorefrontPage.Shop));
    }
  }

  const navToSearch = (event: React.MouseEvent) => {
    event.preventDefault();
    const element = document.querySelector(`#${MOBILE_PRODUCT_SEARCH_INPUT_ID}`) as HTMLInputElement | null;

    if (element && navigationState.currentPage === StorefrontPage.Search) {
      element.focus();
    } else {
      updateNavigation(NavigatePage.action(StorefrontPage.Search));
    }
  }

    return (
      <menu className="bottom-nav">
      <li>
        <a href={restaurantPath(config.storefrontId)} data-view-name="shop" onClick={navToShop}>
          <ShopIcon className="icon streamline-icon" />
          <span>Shop</span>
        </a>
      </li>

      {config.usesSubcategoryDisplay ? <li>
        <a href={storeCategoriesPath(config.storefrontId)} data-view-name="categories" onClick={(e) => changePage(e, StorefrontPage.Categories)}>
          <CategoriesIcon className="icon streamline-icon" />
          <span>Categories</span>
        </a>
      </li> : <></>}

      {config.usesProductSearch ? <li>
        <a href={storeSearchPath(config.storefrontId)} data-view-name="search" onClick={navToSearch}>
          <SearchIcon className="icon streamline-icon" />
          <span>Search</span>
        </a>
      </li> : <></>}

      <li>
        <a href={storeCartPath(config.storefrontId)} data-view-name="cart" onClick={(e) => changePage(e, StorefrontPage.Cart)}>
          <div>
            <span id="bottom-nav-cart-quantity" className="is-completely-hidden"><span className="badge is-quantity is-round is-tiny" aria-label="Number of cart items">{cart?.cartItemCount()}</span></span>
            <CartIcon className="icon streamline-icon" />
          </div>

          <span>Cart</span>
        </a>
      </li>
    </menu>
  );
}

export { BottomNav };
